import { useEffect, useState } from 'react';
import { useDrawer } from '../../../../shared/drawer';
import { Table } from "../../../../elements/table";
import { PageBody } from '../../../../elements/page-body';
import { MultasTabForm } from './multas-tab-form';




export const MultasTab = ({
    item,
    onAction
}: {
    item?: any;
    onAction: () => void;
}) => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);

    const handleNewAction = () => {
        open('common.form-title.new', <MultasTabForm close={handleClose} vehicleId={item} />);
    };

    const handleClose = () => {
        setRefresh(Date.now().toString());
        onAction();
        close();
        window.location.reload();
    };


    return (
        <PageBody
            newAction={handleNewAction}
            newActionTitle={'common.form-title.new'}
            title={'common.label.multas'}
        >
            <Table
                path={`/fleet/sanctions/?vehicle=${item}&`}
                deletePath={`/fleet/sanctions/`}
                callBeforeDrawerClosed={handleClose}
                Form={MultasTabForm}
                withPagination
                refresh={refresh}
                headers={[
                    {
                        key: 'type',
                        subKey: 'name',
                        label: 'common.label.tipos-multa',
                    },
                    {
                        key: 'date',
                        type: 'datetime',
                        label: 'common.label.fecha-hora',
                    }, 
                    {
                        key: 'location',
                        label: 'common.label.ubicacion',
                    },
                    {
                        key: 'amount',
                        label: 'common.form-label.importe',
                    },
                    {
                        key: 'issuing_entity',
                        label: 'common.label.entidad-emisora',
                    },
                    {
                        key: 'state',
                        subKey: 'name',
                        label: 'common.label.estados-multa',
                    },
                    {
                        key: 'status',
                        type: 'status',
                        label: 'common.label.estado',
                    },
                ]}
            />
        </PageBody>
    );
};